<template>
  <div>
    <MobileFetchData
      :transactions="transactions"
      :isMobile="isMobile"
      @showModal="showModal"
    ></MobileFetchData>
    <div
      class="row"
      style="padding-left: 15px; padding-right: 15px"
      v-for="item in transactions"
      :key="item.rowId"
      v-if="isMobile"
    >
      <div class="col-md-12 content-content" style="padding: 0">
        <div class="content-content-inner col-md-12">
          <div class="col-item-zero flex j-center">
            <p
              class="shape-3"
              :class="
                item.transactionType
                  | typeClass(item.transactionType, item.isPartnerTransaction)
              "
            ></p>
          </div>
          <div class="col-item-one flex j-center">
            <span>{{ item.billDate | date }}</span>
          </div>
          <div class="col-item-one flex j-center">
            <span class="text-center">{{ item.storeName }}</span>
          </div>

          <div
            class="col-item-four flex align-center j-center"
            :class="[item.usedBonus != 0 ? 'minus-number' : '']"
          >
            {{ minus(item.usedBonus) }}
          </div>

          <div
            class="col-item-six flex align-center j-center"
            :class="[item.addedBonus != 0 ? 'add-number' : '']"
          >
            {{ add(item.addedBonus) }}
          </div>
          <div class="col-item-seven flex align-center j-end">
            <span class="b-color">{{
              item.totalAmount | pricewithindexof
            }}</span>
          </div>
          <div class="col-item-seven flex align-center j-end">
            <div class="b-color" @click="showModal(item)">
              <font-awesome-icon  icon="eye" size="lg"/>
            </div>
            &nbsp;&nbsp;
            <div class="b-color" @click="showBill(item)">
              <font-awesome-icon icon="search" size="lg"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MobileFetchData from "./MobileFetchData";

export default {
  props: ["transactions"],
  data() {
    return {
      isMobile: true,
      windowWidth: 0,
      windowHeight: 0,
    };
  },
  methods: {
    showModal(value) {
      this.$emit("openModal", value);
    },
    showBill(value) {
       this.$emit("openBill", value);
    },
    getWindowWidth() {
      this.windowWidth = document.documentElement.clientWidth;
      if (this.windowWidth <= 767) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },
    minus(value) {
      if (value != 0) {
        let add_value = this.changeNumber(value);
        return "-" + add_value;
      } else {
        return value;
      }
    },
    add(value) {
      if (value != 0) {
        let add_value = this.changeNumber(value);
        return "+" + add_value;
      } else {
        return value;
      }
    },
    changeNumber(value) {
      if (value > 0) {
        var converted = value.toString();
        var position = converted.indexOf(".");
        if (position > "0") {
          var returned_value = converted.substring(0, position);
          return Number(returned_value).toLocaleString();
        }
        return Number(value).toLocaleString();
      }
      return Number(value).toLocaleString();
    },
  },
  created() {
    this.$nextTick(function () {
      window.addEventListener("resize", this.getWindowWidth);
      //Init
      this.getWindowWidth();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowWidth);
  },
  components: {
    MobileFetchData,
  },
};
</script>
